import AuthApi from '@/services/api/auth.service'
import moment from 'moment'

export function makeStore(vueAuth) {
  return {
    namespaced: true,

    state: {
      isAuthenticated: vueAuth.isAuthenticated(),
      token: vueAuth.getToken(),
      payload: vueAuth.getPayload(),
      isSending: false,
      deploymentAuth: {
        access_token: window.sessionStorage.getItem('deyployment_auth'),
        expires_at: parseInt(<string>window.sessionStorage.getItem('deyployment_expiration')),
      }
    },

    mutations: {
      SET_AUTH(state, [token, payload]) {
        state.isAuthenticated = true
        state.token = token
        state.payload = payload
      },
      RESET_AUTH(state) {
        state.isAuthenticated = false
        state.token = null
        state.payload = {}
      },
      SET_SENDING(state) {
        state.isSending = true
      },
      RESET_SENDING(state) {
        state.isSending = false
      },
      SET_DEPLOYMENT_AUTH(state, {access_token, expires_at}) {
        state.deploymentAuth = {
          access_token,
          expires_at: expires_at * 1000,
        }
        let time = expires_at * 1000
        window.sessionStorage.setItem('deyployment_auth', access_token)
        window.sessionStorage.setItem('deyployment_expiration', time.toString())
      },
      SIGNOUT_DEPLOYMENT_AUTH(state) {
        state.deploymentAuth = {
          expires_at: null,
          access_token: null
        }
        window.sessionStorage.removeItem('depluyment_auth')
        window.sessionStorage.removeItem('depluyment_expiration')
      }
    },

    actions: {
      signup({ commit, dispatch }, { name, email, password, text }) {
        commit('SET_SENDING')
        return vueAuth
          .register({
            name,
            email,
            password,
            text
          })
          .then(() => commit('SET_AUTH', [vueAuth.getToken(), vueAuth.getPayload()]))
          .then(() => dispatch('getUserPrefs', {}, { root: true }))
          .finally(() => commit('RESET_SENDING'))
      },
      login({ commit, dispatch }, credentials) {
        return vueAuth
          .login(credentials)
          .then(() => commit('SET_AUTH', [vueAuth.getToken(), vueAuth.getPayload()]))
          .then(() => {
            // logged in successfully
            dispatch('getUserPrefs', {}, { root: true })

            // dispatch fetch projects
            dispatch('GET_PROJECTS')
          })
          .catch((error) => { throw error})
      },
      authenticate({ commit, dispatch }, provider) {
        return vueAuth
          .authenticate(provider)
          .then((authResponse) => {
            commit('SET_AUTH', [vueAuth.getToken(), vueAuth.getPayload()])
          })
          .then(() => dispatch('getUserPrefs', {}, { root: true }))
          .catch((error) => { throw error})
      },
      setToken({ commit, dispatch }, token) {
        vueAuth.setToken(token)
        commit('SET_AUTH', [token, vueAuth.getPayload()])
        dispatch('getUserPrefs', {}, { root: true })
      },
      confirm({ commit }, token) {
        return AuthApi.confirm(token)
      },
      forgot({ commit }, email) {
        commit('SET_SENDING')
        return AuthApi
          .forgot(email)
          .finally(() => commit('RESET_SENDING'))
      },
      reset({ commit }, [token, password]) {
        return AuthApi.reset(token, password)
      },
      logout({ commit }) {
        return vueAuth
          .logout()
          .then(response => {
            return response
          })
          .finally(() => commit('RESET_AUTH'))
      },
      signinDeployment({ commit }, {access_token, expires_at}) {
        commit('SET_DEPLOYMENT_AUTH', {access_token, expires_at})
      },
      signoutDeployment({ commit }) {
        commit('SIGNOUT_DEPLOYMENT_AUTH')
      }
    },

    getters: {
      getToken(state) {
        return state.token
      },
      getOptions() {
        return vueAuth.options
      },
      getPayload(state) {
        return state.payload
      },
      isLoggedIn(state) {
        return state.isAuthenticated
      },
      getUsername(state) {
        return state.payload && state.payload.preferred_username
      },
      getAvatar(state) {
        return state.payload && state.payload.picture
      },
      scopes(state) {
        return state.payload && state.payload.scope ? state.payload.scope.split(' ') : []
      },
      isAdmin(state, getters) {
        if (getters.isLoggedIn) {
          return getters.scopes.includes('admin')
        }
        return false
      },
      hasValidToken(state) {
        if(state.deploymentAuth.access_token && state.deploymentAuth.expires_at) {
          return moment().isBefore(moment(state.deploymentAuth.expires_at))
        } else {
          return false
        }
      },
      getDeploymentToken(state) {
        return state.deploymentAuth.access_token
      },
    }
  }
}
